import { Component, inject, signal } from '@angular/core';
import { TrackingConsentStatus } from './tracking-consent.interfaces';
import { TrackingService } from '../tracking.service';

@Component({
  selector: 'app-tracking-consent-banner',
  standalone: true,
  imports: [],
  templateUrl: './tracking-consent-banner.component.html',
  styleUrl: './tracking-consent-banner.component.scss',
})
export class TrackingConsentBannerComponent {
  trackingService = inject(TrackingService);
  consentAsked = signal(true);

  constructor() {
    // Delay `consentAsked` by 1 "frame" so that banner first gets rendered
    // with `translate-y-full` class attached. If consent hasn't been asked yet,
    // this class is dropped the next frame and the banner slides in animated.
    setTimeout(() => {
      this.consentAsked.set(this.trackingService.getTrackingConsent() !== null);
    });
  }

  denyTracking() {
    this.trackingService.setTrackingConsent(TrackingConsentStatus.Denied);
    this.consentAsked.set(true);
  }

  acceptTracking() {
    this.trackingService.setTrackingConsent(TrackingConsentStatus.Granted);
    this.consentAsked.set(true);
  }
}
